import React, { useContext, useEffect, useState } from "react";
import { Modal, Form } from "react-bootstrap";
import {
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  TextField,
} from "@mui/material";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { requestAxios, ComboBox } from "../../../../util/util";
import AppContext from "../../../../Context/AppContext";
import "./ModalAdicion.css";

const ModalAdicion = ({
  show,
  setShow,
  setCurrentRow,
  currentRow,
  acreditadoInfo,
}) => {
  const { checkUserSession, changeLoading } = useContext(AppContext);
  const [cmbPaises, setCmbPaises] = useState([]);
  const [cmbEstados, setCmbEstados] = useState([]);
  const [validated, setValidated] = useState(false);
  const infoUs = checkUserSession();

  useEffect(() => {
    loadInfo();
  }, []);
  async function loadInfo() {
    var listPais = await ComboBox.cmbPaises(infoUs);
    var listEstados = await ComboBox.cmbEstados(infoUs, 25);
    setCmbPaises(listPais);
    setCmbEstados(listEstados);
  }
 
  
    return (
    <Modal
      show={show}
      onHide={() => setShow(false)}
      dialogClassName="modal-90wDirecciones"
      aria-labelledby="example-custom-modal-styling-title"
    >
      <Modal.Header closeButton>
        <Modal.Title
          id="AcreditadoDetalleModalTitle"
          className="ModalDomiciliosModalTitle"
        >
          Agregar: <span>Nuevo Dato de Contacto</span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form noValidate validated={validated} className="modalAdicionDireccion__FullBody">
          <div className="modalAdicionDireccion__bodycontainer1">
            <TextField
              id="outlined-basic"
              label="RFC"
              variant="outlined"
              className="txtDireccionCalle"
              value={currentRow["RFC"]}
            />
            <TextField
              id="outlined-basic"
              label="Nombre"
              variant="outlined"
              className="txtDireccionCalle"
              value={currentRow["Nombre"]}
            />
          </div>
          <div className="modalAdicionDireccion__bodycontainer2">
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">País</InputLabel>
              <Select
                required
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                label={<div className="cmbTipoGestionTitle">País</div>}
                value={25}
              >
                {cmbPaises.map((item, i) => (
                  <MenuItem
                    key={`cmbPais-Id${i}`}
                    className="cmbTipoGestion_Item"
                    value={item.Id}
                  >
                    {item.Text}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Estado</InputLabel>
              <Select
                required
                className="cmbTipoGestion"
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                label={<div className="cmbTipoGestionTitle">Estado</div>}
                value={currentRow.Estado}
              >
                {cmbEstados.map((item, i) => (
                  <MenuItem
                    key={`cmbTipoGestion_Item${i}`}
                    className="cmbTipoGestion_Item"
                    value={item.Id}
                  >
                    {item.Text}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <TextField
              id="outlined-basic"
              label="Ciudad"
              variant="outlined"
              className="txtDireccionCalle"
              value={currentRow["Ciudad"]}
            />
          </div>

          <div className="modalAdicionDireccion__bodycontainer2">
            <TextField
              id="outlined-basic"
              label="Municipio"
              variant="outlined"
              className="txtDireccionCalle"
              value={currentRow["Municipio"]}
            />
            <TextField
              id="outlined-basic"
              label="Colonia"
              variant="outlined"
              className="txtDireccionCalle"
              value={currentRow["Colonia"]}
            />
            <TextField
              id="outlined-basic"
              label="Código Postal."
              variant="outlined"
              className="txtDireccionCalle"
              value={currentRow["Codpos"]}
            />
          </div>
          <div className="modalAdicionDireccion__bodycontainer1">
            <TextField
              id="outlined-basic"
              label="Teléfono"
              variant="outlined"
              className="txtDireccionCalle"
              value={currentRow["Tel"]}
            />
            <TextField
              id="outlined-basic"
              label="Dirección"
              variant="outlined"
              className="txtDireccionCalle"
              value={currentRow["Domicilio"]}
            />
          </div>
          <br/>
          <h2>Trabajo</h2>
          <div className="modalAdicionDireccion__bodycontainer2">
            <div>
              <TextField
                id="outlined-basic"
                label="Trabajo"
                variant="outlined"
                className="txtDireccionCalle"
                value={currentRow["Trabajo"]}
              />
            </div>
            <TextField
              id="outlined-basic"
              label="Puesto"
              variant="outlined"
              className="txtDireccionCalle"
              value={currentRow["Puesto"]}
            />
            <TextField
              id="outlined-basic"
              label="Telefono"
              variant="outlined"
              className="txtDireccionCalle"
              value={currentRow["TelTrab"]}
            />
            <TextField
              id="outlined-basic"
              label="Municipio del Trabajo"
              variant="outlined"
              className="txtDireccionCalle"
              value={currentRow["MuniTrab"]}
            />
            <TextField
              id="outlined-basic"
              label="Domicilio del Trabajo"
              variant="outlined"
              className="txtDireccionCalle"
              value={currentRow["DomTrab"]}
            />
          </div>
          <div className="modalAdicion__buttoncontainer modalAdicion__buttoncontainerDirecciones">
           
          </div>
        </Form>
        <button
              className="modalAdicion__btnCancelar"
              type="button"
              onClick={() => setShow(false)}
            >
              Cancelar
            </button>
      </Modal.Body>
    </Modal>
  );
};

export default ModalAdicion;
